import React, { Component } from 'react';
import { CardActions, Filter, TextInput, RefreshButton } from 'react-admin';
import { refreshView as refreshViewAction } from 'ra-core';
import { connect } from 'react-redux';

export const ListFilter = props => (
  <Filter {...props}>
    <TextInput label="Search" source="f" alwaysOn />
  </Filter>
);

class MyListActions extends Component {
  render() {
    return (
      <CardActions>
        <RefreshButton />
      </CardActions>
    );
  }
  componentDidMount() {
    const { refreshInterval, refreshView } = this.props;
    if (refreshInterval) {
      this.interval = setInterval(() => {
        refreshView();
      }, refreshInterval);
    }
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }
}

export const ListActions = connect(
  null,
  { refreshView: refreshViewAction },
)(MyListActions);



// WEBPACK FOOTER //
// ./src/containers/Booking/ListActions.js